import { render, staticRenderFns } from "./TruckListItem.vue?vue&type=template&id=719815fa&scoped=true"
import script from "./TruckListItem.vue?vue&type=script&lang=js"
export * from "./TruckListItem.vue?vue&type=script&lang=js"
import style0 from "./TruckListItem.vue?vue&type=style&index=0&id=719815fa&prod&lang=css"
import style1 from "./TruckListItem.vue?vue&type=style&index=1&id=719815fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719815fa",
  null
  
)

export default component.exports